<template>
  <div class="services" id="servicios">
    <b-container fluid="md">
      <b-row align-h="center">
        <b-col sm="8" class="text-center">
          <h1 class="font-weight-bold mb-3">
            Servicios
          </h1>
          <h2 class="p font-weight-light">
            Somos un equipo capaz de desarrollar, todas o parcialmente, las diferentes instancias o fases del proyecto arquitectónico. 
          </h2>
        </b-col>
        <b-col sm="12" class="text-center my-5">
          <h2 class="h4 color-darken-1">
            Fases de evolución de un proyecto de arquitectura
          </h2>
          <h3 class="p font-weight-light color-darken-1 pb-3">
            Desde el análisis inicial hasta la construcción y recepción del mismo.
          </h3>
          <Fases class="mt-4 d-none d-sm-block" />
        </b-col>
        <b-col sm="12" class="py-3">
          <b-row>
            <template v-for="(service, i) in services">
              <b-col
                sm="6"
                md="4"
                :key="`service-${i}`"
                class="d-flex flex-column color-darken-1 services__item"
              >
                <div class="services__item__content smooth-shadow">
                  <b-img
                    :src="service.icon"
                    :alt="service.name"
                    class="mb-4"
                  ></b-img>
                  <h3>{{ service.name }}</h3>
                  <p
                    class="font-weight-light mb-0"
                    v-html="service.description"
                  />
                </div>
              </b-col>
            </template>
          </b-row>
          <b-row align-h="center" class="mt-4" v-if="largeService">
            <b-col sm="8" class="text-center px-4 px-sm-0">
              <h2>{{ largeService.name }}</h2>
              <p
                class="font-weight-light mt-3 mb-0 px-2 px-sm-0"
                v-html="largeService.description"
              ></p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Fases from "@/assets/services/fases.vue";
import { db } from "../services/firebase";

export default {
  name: "Services",
  components: {
    Fases
  },
  data() {
    return {
      services: [],
      largeService: {}
    };
  },
  async created() {
    await db
      .collection("services")
      .get()
      .then((docs) => {
        let servicesColl = [];

        docs.forEach(function (doc) {
          let newDoc = doc.data();
          newDoc.id = doc.id;
          servicesColl.push(newDoc);
        });

        this.largeService = servicesColl.find(
          (service) => service.large === true
        );

        this.services = servicesColl.filter(
          (service) => service.large === false
        );
      });
  },
  mounted() {
    document.getElementById("main").scrollTo(0, 0); // go to top
  }
};
</script>

<style scoped lang="sass">
@import "@/assets/main.sass"

.services
  margin: 8rem 0
  @media screen and (max-width: 502px)
    text-align: center
  &__item
    padding: 0.5rem
    &:hover, &:focus
      .services__item__content
        background: rgba(map_get($customColors, "lighten-1"), 0.6)
    &__content
      padding: 1.5rem
      img
        max-width: 50px
</style>
